import { render, staticRenderFns } from "./NewTransferBeneficiary.vue?vue&type=template&id=4b444c64"
import script from "./NewTransferBeneficiary.vue?vue&type=script&lang=js"
export * from "./NewTransferBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports